module.exports = __webpack_public_path__ + "static/media/pic-card_credit.e5afdb45.png";